export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/rating/index.js
// module id = ../../../../ng2-bootstrap/rating/index.js
// module chunks = 4